import axios from "./axiosInstance";

// Fetch all raw materials for POS pre-release dropdown
export const fetchAllRawMaterials = async (branchId) => {
    const res = await axios.get(`/pos/all-raw-materials?branch_id=${branchId}`);
    return res.data;
};
